import React, { useState, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import PageHero from "./PageHero";
import emailjs from "@emailjs/browser";

import {
  FaWifi,
  FaBed,
  FaBath,
  FaTv,
  FaCouch,
} from "react-icons/fa";

//import img13 from "../../media/images/garary/g13.jpg";
import img14 from "../../media/images/rooms/FH_UG-201.jpg";
import img15 from "../../media/images/rooms/room2.jpg";
import img17 from "../../media/images/rooms/room5.jpg";
import img18 from "../../media/images/rooms/room6.jpg";

function Rooms() {
  const [show, setShow] = useState(false);
  const [selectedRoom, setSelectedRoom] = useState(null);

  // loading button
  const [loading, setLoading] = useState(false);

  const form = useRef();

  const handleClose = () => setShow(false);

  const handleShow = (room) => {
    setSelectedRoom(room);
    setShow(true);
  };

  // SEND BOOKING EMAIL
  const sendBooking = (e) => {
    e.preventDefault();

    setLoading(true);

    emailjs
      .sendForm(
        "service_kmkcgs3",
        "template_c3asdce",
        form.current,
        "RbnxvBNkLv2JZlm7o"
      )
      .then(
        () => {
          alert("Booking sent successfully ✅");

          form.current.reset();

          setLoading(false);

          handleClose();
        },
        (error) => {
          console.log(error.text);

          alert("Failed to send booking ❌");

          setLoading(false);
        }
      );
  };

  const rooms = [
    {
      id: 1,
      name: "Standard Room",
      price: "$100 / night",
      image: img14,
      features: [
        { icon: <FaWifi />, label: "Free WiFi" },
        { icon: <FaBed />, label: "1 Bed" },
        { icon: <FaBath />, label: "Shower" },
        { icon: <FaTv />, label: "TV" },
      ],
    },
    {
      id: 2,
      name: "Deluxe Room",
      price: "$120 / night",
      image: img15,
      features: [
        { icon: <FaWifi />, label: "Free WiFi" },
        { icon: <FaBed />, label: "2 Beds" },
        { icon: <FaBath />, label: "Hot Shower" },
        { icon: <FaTv />, label: "TV" },
        { icon: <FaCouch />, label: "Balcony" },
      ],
    },
    {
      id: 3,
      name: "Executive Suite",
      price: "$150 / night",
      image: img18,
      features: [
        { icon: <FaWifi />, label: "Free WiFi" },
        { icon: <FaBed />, label: "King Bed" },
        { icon: <FaCouch />, label: "Living Room" },
        { icon: <FaTv />, label: "TV" },
      ],
    },
  ];

  return (
    <>
      <PageHero
        title="Rooms"
        subtitle="Comfortable and affordable rooms for your stay"
        image={img17}
      />

      <div className="container py-5">
        <h2 className="text-center mb-4" data-aos="fade-up">
          Rooms
        </h2>

        <div className="row">
          {rooms.map((room, index) => (
            <div className="col-md-4 mb-4" key={room.id}  data-aos="zoom-in" data-aos-delay={index * 100}>
              <div className="card shadow h-100">
                <img
                  src={room.image}
                  className="card-img-top"
                  alt={room.name}
                />

                <div className="card-body d-flex flex-column">
                  <h5>{room.name}</h5>

                  <span className="badge bg-success mb-2">
                    {room.price}
                  </span>

                  <div className="mb-3">
                    {room.features.map((feature, index) => (
                      <div
                        key={index}
                        className="d-flex align-items-center small mb-1"
                      >
                        <span className="text-success me-2">
                          {feature.icon}
                        </span>

                        <span>{feature.label}</span>
                      </div>
                    ))}
                  </div>

                  <Button
                    variant="success"
                    className="mt-auto"
                    onClick={() => handleShow(room)}
                  >
                    Book Now
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* MODAL */}
        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header closeButton>
            <Modal.Title>
              {selectedRoom ? selectedRoom.name : "Room"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {selectedRoom && (
              <>
                <img
                  src={selectedRoom.image}
                  alt=""
                  className="img-fluid rounded mb-3"
                />

                <h5 className="text-success">
                  {selectedRoom.price}
                </h5>

                <h6 className="mt-3">Room Features</h6>

                <div className="mb-3">
                  {selectedRoom.features.map((f, i) => (
                    <div
                      key={i}
                      className="d-flex align-items-center mb-1"
                    >
                      <span className="text-success me-2">
                        {f.icon}
                      </span>

                      <span>{f.label}</span>
                    </div>
                  ))}
                </div>

                {/* BOOKING FORM */}
                <h6 className="mt-3">Book This Room</h6>

                <form ref={form} onSubmit={sendBooking}>
                  {/* ROOM NAME */}
                  <input
                    type="hidden"
                    name="room_name"
                    value={selectedRoom.name}
                  />

                  {/* ROOM PRICE */}
                  <input
                    type="hidden"
                    name="room_price"
                    value={selectedRoom.price}
                  />

                  <div className="mb-2">
                    <label className="form-label">
                      Full Name
                    </label>

                    <input
                      type="text"
                      className="form-control"
                      name="name"
                      required
                    />
                  </div>

                  <div className="mb-2">
                    <label className="form-label">
                      Email
                    </label>

                    <input
                      type="email"
                      className="form-control"
                      name="email"
                      required
                    />
                  </div>

                  <div className="mb-2">
                    <label className="form-label">
                      Check-in Date
                    </label>

                    <input
                      type="date"
                      className="form-control"
                      name="checkin"
                      required
                    />
                  </div>

                  <div className="mb-3">
                    <label className="form-label">
                      Check-out Date
                    </label>

                    <input
                      type="date"
                      className="form-control"
                      name="checkout"
                      required
                    />
                  </div>

                  <Button
                    type="submit"
                    variant="success"
                    className="w-100 d-flex justify-content-center align-items-center"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                        ></span>

                        Sending Booking...
                      </>
                    ) : (
                      "Confirm Booking"
                    )}
                  </Button>
                </form>
              </>
            )}
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default Rooms;